<template>
  <div class="row mt-6" id="csca-stats">
    <div class="col-12 col-md-4">
      <h3 :class="{ 'white-text': whitetext }">
        <span id="yearContainer">0</span>
        <span class="shrink" style="margin-left: -8px;">+ years</span>
      </h3>
      <p class="gold-text">in business</p>
    </div>
    <div class="col-12 col-md-4">
      <h3 :class="{ 'white-text': whitetext }">
        <span class="shrink">$</span>
        <span id="dollarContainer">0</span>
        <span class="shrink" style="margin-left: -8px;">+ billion</span>
      </h3>
      <p class="gold-text">
        value of completed
        <br />transactions
      </p>
    </div>
    <div class="col-12 col-md-4">
      <h3 :class="{ 'white-text': whitetext }">
        <span id="transactionContainer">0</span>
        <span class="shrink" style="margin-left: -8px;">+</span>
      </h3>
      <p class="gold-text">number of completed transactions</p>
    </div>
    <div class="col-12 text-center mt-5">
      <img src="@/assets/csca-icon-gold.svg" alt="CS Capital Advisors" />
    </div>
  </div>
</template>

<script>
import { TweenLite, Power2 } from "gsap";
export default {
  props: {
    whitetext: Boolean,
    autoload: Boolean
  },
  data() {
    return {
      years: 20,
      totalDollars: 75,
      transactions: 300,
      animated: false,
      ticking: false,
      scrollPos: 0,
      windowHeight: 0
    };
  },
  methods: {
    scrollTrigger() {
      var comp = this;
      window.addEventListener("scroll", function() {
        if (!comp.animated) {
          comp.scrollPos = window.pageYOffset;
          if (!this.ticking) {
            window.requestAnimationFrame(function() {
              comp.checkPositions(comp.scrollPos);
              comp.ticking = false;
            });

            comp.ticking = true;
          }
        }
      });
    },
    checkPositions() {
      var bottomPos = this.scrollPos + this.windowHeight;
      var el = document.getElementById("csca-stats");
      var elPos = el.getBoundingClientRect().top + this.scrollPos;
      if (bottomPos >= elPos) {
        this.countStats();
        this.animated = true;
      }
    },
    countStats() {
      var yearCount = { val: 0 },
        dollarCount = { val: 0 },
        transactionCount = { val: 0 },
        yearContainer = document.getElementById("yearContainer"),
        dollarContainer = document.getElementById("dollarContainer"),
        transactionContainer = document.getElementById("transactionContainer");
      TweenLite.to(yearCount, 1.5, {
        val: this.years,
        roundProps: "val",
        onUpdate: function() {
          yearContainer.innerHTML = yearCount.val;
        }
      });
      TweenLite.to(dollarCount, 1.5, {
        val: this.totalDollars,
        roundProps: "val",
        onUpdate: function() {
          dollarContainer.innerHTML = dollarCount.val;
        },
        ease: Power2.easeOut
      });
      TweenLite.to(transactionCount, 1.5, {
        val: this.transactions,
        roundProps: "val",
        ease: Power2.easeInOut,
        onUpdate: function() {
          transactionContainer.innerHTML = transactionCount.val;
        }
      });
    }
  },
  mounted() {
    this.scrollPos = window.pageYOffset;
    this.windowHeight = window.innerHeight;
    if (this.autoload) {
      this.countStats();
    } else {
      this.scrollTrigger();
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 0;
  .shrink {
    font-size: 2rem;
  }
}
p {
  font-size: 1.5rem;
  text-align: center;
  line-height: 1em;
}
#yearContainer,
#dollarContainer,
#transactionContainer {
  margin-right: 8px;
}
</style>
